import type { IconNode } from '../types';

/**
 * @name candle-holder
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cmVjdCB3aWR0aD0iNCIgaGVpZ2h0PSI3IiB4PSI4IiB5PSIxMSIgLz4KICA8cGF0aCBkPSJNMTggMThhNCA0IDAgMCAxLTQgNEg2YTQgNCAwIDAgMS00LTRoMThhMiAyIDAgMSAwLTItMloiIC8+CiAgPHBhdGggZD0iTTEwIDl2MiIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/candle-holder
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const candleHolder: IconNode = [
  ['rect', { width: '4', height: '7', x: '8', y: '11', key: '11vyao' }],
  ['path', { d: 'M18 18a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4h18a2 2 0 1 0-2-2Z', key: '13174f' }],
  ['path', { d: 'M10 9v2', key: '1lvof4' }],
];

export default candleHolder;
